﻿$(function () {
	function onOpenTour(eventObject: JQueryEventObject) {
		$(document).off("click", "[data-open='tour']", (<any>onOpenTour));

		if (!$("#tour").length) {
			$("<div></div>")
				.attr("id", "tour-container")
				.addClass("loading-overlay")
				.text("Loading tour...")
				.appendTo($(document.body));

			$("#tour-container").load("/tour", () => {
				$("#tour-container").removeClass("loading-overlay");

				$("#tour-styles").on("load", () => {
					window.requestAnimationFrame(() => {
						setTimeout(() => ko.dataFor(document.getElementById("tour")).open(), 250);
					});
				});
			});
		}
	}

	$(document).on("click", "[data-open='tour']", onOpenTour);
});